import { createSlice } from '@reduxjs/toolkit';

export const NULL_COUNT = 0;

export interface CourseInfoListSliceState {
    courseInfoVisibile: boolean;
    itemCount: number;
    disciplineId: string;
}

export const CourseInfoListSlice = createSlice({
    name: 'courseInfoVisibile',
    initialState: {
        courseInfoVisibile: false,
        itemCount: NULL_COUNT,
        disciplineId: '',
    },
    reducers: {
        toggle: (state, action) => {
            state.courseInfoVisibile = action.payload;
        },
        setItemCount: (state, action) => {
            state.itemCount = action.payload;
        },
        setDiscipline: (state, action) => {
            state.disciplineId
                = action.payload;
        },
    },
});

export default CourseInfoListSlice
export const CourseInfoLisActions = CourseInfoListSlice.actions
export const CourseInfoLisSelector = (store: { courseInfo: CourseInfoListSliceState }): CourseInfoListSliceState => store.courseInfo;
import { createSlice } from '@reduxjs/toolkit';

export const NULL_COUNT = 0;

export interface CourseInfoListSliceState {
    courseInfoVisibile: boolean;
    itemCount: number;
    disciplineId: string;
}

export const CourseInfoListSlice = createSlice({
    name: 'courseInfoVisibile',
    initialState: {
        courseInfoVisibile: false,
        itemCount: NULL_COUNT,
        disciplineId: '',
    },
    reducers: {
        toggle: (state, action) => {
            state.courseInfoVisibile = action.payload;
        },
        setItemCount: (state, action) => {
            state.itemCount = action.payload;
        },
        setDiscipline: (state, action) => {
            state.disciplineId
                = action.payload;
        },
    },
});

export default CourseInfoListSlice
export const CourseInfoLisActions = CourseInfoListSlice.actions
export const CourseInfoLisSelector = (store: { courseInfo: CourseInfoListSliceState }): CourseInfoListSliceState => store.courseInfo;
